import { Link } from "react-router-dom";
import { School } from "lucide-react";
import { defineModuleUi, useOrg } from "@vixio/data";
import { StatusFromMap, formatDate, lazyPage } from "@vixio/ui";
import { STAGE, usePipeline } from "./api";

export * from "./api";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const InpesPage = lazyPage(() => import("./InpesPage"), "InpesPage");
const OpportunityPage = lazyPage(() => import("./OpportunityPage"), "OpportunityPage");

function PipelineWidget() {
  const org = useOrg();
  const q = usePipeline(org.id);
  const open = (q.data ?? []).filter((r) => !["contratada", "perdida", "suspensa"].includes(r.stage)).slice(0, 5);
  if (!open.length) return <p className="muted">Nenhuma oportunidade institucional aberta.</p>;
  return (
    <ul className="vx-stack" style={{ gap: 8, margin: 0, padding: 0, listStyle: "none" }}>
      {open.map((r) => (
        <li key={r.id} className="vx-row vx-row--between" style={{ flexWrap: "nowrap" }}>
          <span style={{ minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            <Link to={`/gestao/inpes/oportunidades/${r.id}`}>{r.agency}</Link>
            {r.next_step_on ? <span className="text-2 num"> · {formatDate(r.next_step_on)}</span> : null}
          </span>
          <StatusFromMap map={STAGE} value={r.stage} />
        </li>
      ))}
    </ul>
  );
}

export default defineModuleUi({
  key: "inpes",
  title: "InPES",
  domain: "governance",
  icon: School,
  menu: [{ path: "/gestao/inpes", label: "InPES institucional", minRole: "member", icon: School, order: 50, keywords: "prefeitura órgão público licitação lei 14.133 inexigibilidade dispensa conflito de interesse preço de referência" }],
  routes: [
    { path: "/gestao/inpes", element: <InpesPage />, minRole: "member" },
    { path: "/gestao/inpes/oportunidades/:id", element: <OpportunityPage />, minRole: "member" },
  ],
  widgets: [{ key: "inpes.pipeline", title: "InPES: oportunidades", minRole: "member", span: 1, order: 76, element: PipelineWidget }],
});
